import { useStaticQuery, graphql } from 'gatsby';

const { apollo: mapRefinements } = require('../../../helpers/map-refinements');

const useSRPs = () => {
  const { srps } = useStaticQuery(graphql`
    query UseSRPS {
      srps: allStrapiSearchResultsPage {
        nodes {
          id
          title
          refinements: allRefinements {
            field
            operator
            value
          }
          pages {
            slug
          }
          vehicleDetailPage {
            id
            documentId
            strapiId: strapi_id
            vdpType
            slugPrefix
            formPagePath
            prices {
              id
              field
              variant
              append
              prepend
              appendBTWWhenIncl
              appendBTWWhenExcl
            }
          }
        }
      }
    }
  `);

  return srps.nodes.map((srp) => ({
    ...srp,
    refinements: mapRefinements(srp.refinements),
  }));
};

export default useSRPs;
